import { useT } from '../../../i18n';
import type { KhoaDich } from '../../../i18n';
import { viCanhBao } from '../../../i18n/messages/canh-bao.vi';
import { khoaLoai } from '../nghiep-vu/canh-bao';
import type { MaKenh } from '../types';

/**
 * Dịch các mã động của danh mục (loại cảnh báo, trường của form, tuỳ chọn). Backend thêm mã mới trước khi giao diện
 * có bản dịch thì hiện **nguyên mã**, không hiện chuỗi khoá: tra sự có mặt trong catalog nguồn `canh-bao.vi.ts`.
 */
export function useDichCanhBao() {
  const { t } = useT();
  const co = (nhom: Record<string, unknown>, khoa: string) => Object.prototype.hasOwnProperty.call(nhom, khoa);
  const truong = viCanhBao.canhBaoTruong as Record<string, Record<string, string>>;
  const goiY = viCanhBao.canhBaoGoiY as Record<string, Record<string, string>>;

  return {
    tenKenh: (ma: MaKenh | string) => (co(viCanhBao.canhBaoMa.kenh, ma) ? t(`canhBaoMa.kenh.${ma}` as KhoaDich) : ma),
    moKenh: (ma: MaKenh) => (co(viCanhBao.canhBaoMa.moKenh, ma) ? t(`canhBaoMa.moKenh.${ma}` as KhoaDich) : ''),
    huongDan: (ma: MaKenh) => (co(viCanhBao.canhBaoMa.huongDan, ma) ? t(`canhBaoMa.huongDan.${ma}` as KhoaDich) : ''),
    tenLoai: (code: string) => {
      const k = khoaLoai(code);
      return co(viCanhBao.canhBaoLoai.ten, k) ? t(`canhBaoLoai.ten.${k}` as KhoaDich) : code;
    },
    moLoai: (code: string) => {
      const k = khoaLoai(code);
      return co(viCanhBao.canhBaoLoai.mo, k) ? t(`canhBaoLoai.mo.${k}` as KhoaDich) : '';
    },
    nhanTruong: (kenh: MaKenh, key: string) =>
      truong[kenh] && co(truong[kenh], key) ? t(`canhBaoTruong.${kenh}.${key}` as KhoaDich) : key,
    goiYTruong: (kenh: MaKenh, key: string) =>
      goiY[kenh] && co(goiY[kenh], key) ? t(`canhBaoGoiY.${kenh}.${key}` as KhoaDich) : undefined,
    nhanThamSo: (key: string) =>
      co(viCanhBao.canhBaoLoai.thamSo, key) ? t(`canhBaoLoai.thamSo.${key}` as KhoaDich) : key,
    nhanTuyChon: (gia: string) =>
      co(viCanhBao.canhBaoLoai.tuyChon, gia) ? t(`canhBaoLoai.tuyChon.${gia}` as KhoaDich) : gia,
    lyDo: (ma: string | null | undefined) =>
      ma && co(viCanhBao.canhBaoMa.lyDo, ma) ? t(`canhBaoMa.lyDo.${ma}` as KhoaDich) : (ma ?? ''),
    loiGui: (ma: string | null | undefined) =>
      ma && co(viCanhBao.canhBaoMa.loiGui, ma) ? t(`canhBaoMa.loiGui.${ma}` as KhoaDich) : (ma ?? ''),
  };
}
